<template>
    <div class="app-body">
        <bread-crumb></bread-crumb>
        <el-card class="content">
            <el-form :model="form" ref="form" :rules="rules" label-width="120px" label-position="left">
                <el-form-item label="标的名称" prop="name">
                    <el-input style="width: 400px" v-model="form.name" maxlength="50" placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item label="资方公司" prop="companyId">
                    <le-company-investors-select v-model="form.companyId" :readonly="id?true:false" style="padding: 0 !important;width: 400px"></le-company-investors-select>
                </el-form-item>
                <el-form-item label="标的投资金额" prop="investAmount">
                    <jd-input-price v-model="form.investAmount" style="width:240px"></jd-input-price>
                </el-form-item>
                <el-form-item label="兜底收益(月)" prop="baseAmount">
                    <jd-input-price v-model="form.baseAmount" style="width:240px"></jd-input-price>
                    <div class="a-flex-rsbc a-mt-10" style="width:547px" v-if="form.baseAmount && form.baseAmount !== '0'">
                        <span class="a-fs-14 a-fw-700">补足分担比列：</span>
                        <el-button size="mini" type='primary' @click="addCarryVo">添加承担方</el-button>
                    </div>
                    <div class="subsidy-content a-flex-rfsc" v-for="(item, index) in form.carryVoList" :key="index">
                        <span class="carryVoPlatform" v-if="item.companyId == 2">毛豆充平台</span>
                        <le-company-under-select v-else v-model="item.companyId" style="padding: 0 !important;"></le-company-under-select>
                        <jd-input-twonum appendText='%' v-model="item.ratio" style="width:240px;margin-left:10px"></jd-input-twonum>
                        <el-button type="danger" icon="el-icon-delete" circle size='mini' class="a-ml-10" @click="delCarryVo(index)"></el-button>
                    </div>
                </el-form-item>
                <el-form-item label="预期收益率" prop="expectRatio">
                    <jd-input-twonum appendText='%' v-model="form.expectRatio" style="width:240px"></jd-input-twonum>
                </el-form-item>
                <el-form-item label="日期范围" prop="dateRange">
                    <div class="a-flex-rfsc">
                        <el-date-picker
                            v-model="form.dateRange"
                            type="monthrange"
                            value-format='yyyy-MM-dd'
                            range-separator="至"
                            start-placeholder="起始时间"
                            end-placeholder="结束时间">
                        </el-date-picker>
                        <span class="a-ml-10">共</span>
                        <span class="a-fw-700 a-plr-7">{{ dateNum }}</span>
                        <span>期</span>
                    </div>
                </el-form-item>
            </el-form>
            <div style="height: 100px;"></div>
            <div class="a-line-t-e0 footerBox">
                <el-button type="primary" class="a-ml-24 a-mt-15" @click="submit">立即提交</el-button>
                <el-button class="a-ml-24 a-mt-15" style="margin-left: 24px" @click="cancelSubmit">返回</el-button>
            </div>
        </el-card>
    </div>
</template>

<script>
    export default {
        data() {
            var checkCarryVoList = (rule, value, callback) => {
                if(this.form.baseAmount === '0' || this.form.baseAmount === 0) {
                    callback(new Error('兜底收益须大于0'))
                }else if(this.form.baseAmount && this.form.baseAmount !== '0') {
                    console.log(this.form.baseAmount,'this.form.baseAmount');
                    if(!this.form.carryVoList.length) {
                        callback(new Error('请至少选择一个承担方'))
                    }else {
                        let allRatio = 0, isEmpty = false
                        this.form.carryVoList.map(item=>{
                            if(!item.ratio || item.ratio === '0') {
                                isEmpty = true
                            }
                            allRatio += Number(item.ratio)
                        })

                        if(isEmpty) {
                            callback(new Error('请完整填写承担方比例'))
                        }else if(allRatio != 100) {
                            callback(new Error('各方承担方比例总和须等于100'))
                        }else {
                            callback()
                        }
                    }
                }else {
                    callback()
                }
            };
            var checkExpectRatio = (rule, value, callback) => {
                if(Number(this.form.expectRatio) > 100) {
                    callback(new Error('预期收益率不可大于100'))
                }else {
                    callback()
                }
            };
            
            return {
                id: '',
                form: {
                    name: '',
                    companyId: '',
                    investAmount: '',
                    baseAmount: '',
                    carryVoList: [],
                    dateRange: [],
                    expectRatio: '',
                },
                rules: {
                    name: [{required: true, message:'请输入标的名称', trigger: 'blur'}],
                    companyId: [{required: true, message:'请选择资方公司', trigger: 'blur'}],
                    investAmount: [{required: true, message:'请输入标的投资金额', trigger: 'blur'}],
                    baseAmount: [{ validator: checkCarryVoList, trigger: 'change' }],
                    expectRatio: [{required: true, message:'请输入预期收益率', trigger: 'blur'},{ validator: checkExpectRatio, trigger: 'blur' }],
                    dateRange: [{required: true, message:'请选择标的日期范围', trigger: 'change'}],
                },
            };
        },
        computed: {
            dateNum () {
                if(this.form.dateRange.length) {
                    return this.$getDay.enumerateMonthsBetweenDates(this.form.dateRange[0], this.form.dateRange[1]).length
                }else {
                    return 0
                }
            }
        },
        created () {
            this.$getDic('importLevel','select').then(res=>{ this.importanceLevelDic = res; })
            this.id = this.$route.query.id
            if(this.id) this.getInfo()
        },
        mounted () {

        },
        watch: {
            'form.baseAmount': {
                handler (val) {
                    if(val !== '0' && val) {
                        let targetInfo = this.form.carryVoList.find(res=>{
                            return res.companyId == 2
                        })
                        if(!targetInfo) {
                            this.form.carryVoList.unshift({
                                companyId: 2,
                                ratio: ''
                            })
                        }
                    }else {
                        this.form.carryVoList = []
                    }
                }
            }
        },
        methods: {
            getInfo () {
                this.$Axios._get({
                    url: this.$Config.apiUrl.underlyingInfo,
                    params: {
                        id: this.id
                    },
                })
                .then(({data})=>{
                    this.form = {
                        ...data,
                        dateRange: [this.$getDay.getTimeStampToStr(data.startDate, 'YYYY-MM-DD'), this.$getDay.getTimeStampToStr(data.endDate, 'YYYY-MM-DD')],
                        investAmount: data.investAmount ? Number((data.investAmount/100).toFixed(2)) : '',
                        baseAmount: data.baseAmount ? Number((data.baseAmount/100).toFixed(2)) : '',
                    }
                })
                .catch(err=>{

                })
            },
            addCarryVo () {
                this.form.carryVoList.push({
                    companyId: '',
                    ratio: ''
                })
            },
            delCarryVo (index) {
                this.form.carryVoList.splice(index, 1)
            },
            submit () {
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        this.$confirm('是否确认提交？', '温馨提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(_=>{
                            let reqData
                            reqData = {
                                ...this.form,
                                startDate: this.form.dateRange[0],
                                endDate: this.form.dateRange[1],
                                investAmount: this.form.investAmount ? (this.form.investAmount*100).toFixed(0) : '',
                                baseAmount: this.form.baseAmount ? (this.form.baseAmount*100).toFixed(0) : '',
                                totalTerm: this.dateNum,
                            }
                            this.$Axios._post({
                                url: this.$Config.apiUrl.underlyingEdit,
                                method: "post",
                                params: reqData,
                            })
                            .then(res=>{
                                if (res.result.code == 0) {
                                    this.$message.success('标的创建成功')
                                    this.$router.back()
                                    this.$store.dispatch("delView", this.$route);
                                } else {
                                    this.$message.error(res.result.message)
                                }
                            })
                            .catch(err=>{

                            })
                        }).catch(err=>{ console.log(err); })
                    }
                })
                
            },
            cancelSubmit () {
                this.$confirm('是否确认返回？','温馨提示')
                .then(_=>{
                    this.$router.back()
                    this.$store.dispatch("delView", this.$route);
                })
                .catch(_=>{})
            },
        },
    }
</script>

<style lang="scss" scoped>
    .content{
        font-size: 14px;
        height: 100%;
        overflow-y: auto;
        .subsidy-content{
            padding: 10px;
            border-radius: 4px;
            background: #F2F6FC;
            margin-top: 10px;
            width: fit-content;
        }
        /deep/ .el-range-separator{
            width: 20px !important;
        }
        .carryVoPlatform{
            width: 240px;
            height: 32px;
            line-height: 32px;
            padding: 0 15px;
            background: #f5f7fa;
            border: 1px solid #e4e7ed;
            border-radius: 4px;
            color: #c0c4cc;
        }
    }
</style>